import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import moment from 'moment';

import { StatusPageStore } from '@store';
import { StatusType } from '@vi-iot/client';

import { CommonStandaloneModule } from '../../common-standalone.module';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-status-page',
  templateUrl: './status-page.component.html',
  styleUrls: ['./status-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonStandaloneModule, MatIconModule],
})
export class StatusPageComponent implements OnInit {
  readonly StatusPageStatus = StatusType;

  statusPageType = StatusType;

  constructor(public statusPageStore: StatusPageStore) {}

  ngOnInit(): void {
    this.statusPageStore.getStatus();
    this.statusPageStore.getMaintenances();
  }

  isReminderDate(maintenanceDate: string): boolean {
    if (maintenanceDate) {
      const reminderDate = moment(maintenanceDate).subtract(8, 'd');

      return moment(new Date()).isBetween(reminderDate, maintenanceDate);
    } else {
      return false;
    }
  }
}
